import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';

export const Disclaimer: React.FC<{
  text: string;
  className?: string;
  'data-testid'?: string;
}> = ({text, className, 'data-testid': dataTestid}) => (
  <StyledText
    data-testid={dataTestid}
    className={className}
    dangerouslySetInnerHTML={{__html: text}}
  />
);

const StyledText = styled.span`
  --text-color: ${COLORS['Text.Grey']};
  text-align: center;
  color: var(--text-color);
  line-height: 1.5;
  font-weight: ${FONT_WEIGHTS.mediumBold};
  font-size: ${FONT_SIZES.px12};

  a {
    color: var(--text-color);
    text-decoration: underline;
  }
`;
